import { useMemo } from 'react';
import type { FormControlModel, FormFieldModel } from '@generated';
import { FormField } from './FormField';
import { FormControlsAndFieldsContextProvider } from './FormControlsAndFieldsContext';

import { useForm } from '~/shared/forms/FormContext';
import { hideControlsAndOptions } from './hide';
import { suggestOptions } from './suggestions';
import type { FormControlModelExtended } from './types';

export function FormFields({
	formControls,
	formFields,
	additionalProcessing
}: {
	formControls: FormControlModel[];
	formFields: FormFieldModel[];
	additionalProcessing?: (formControls: FormControlModelExtended[]) => FormControlModelExtended[];
}) {
	const {
		formHelpers: { values }
	} = useForm();
	const formControlsWithHiddenLogicApplied = useMemo(() => {
		return hideControlsAndOptions(formControls, formFields, values);
	}, [formControls, formFields, values]);

	const transformedFormControls = useMemo(() => {
		return suggestOptions(formControlsWithHiddenLogicApplied, values);
	}, [formControlsWithHiddenLogicApplied, values]);

	const additionallyProcessed = additionalProcessing ? additionalProcessing(transformedFormControls) : transformedFormControls;

	return (
		<FormControlsAndFieldsContextProvider formControls={additionallyProcessed} formFields={formFields}>
			{additionallyProcessed.map((controlModel, index) => {
				return <FormField key={`${controlModel.name ?? controlModel.controlType}-${index}`} controlModel={controlModel} />;
			})}
		</FormControlsAndFieldsContextProvider>
	);
}
